<script>
    import {GalleryTitleIcon, NextIcon, PrevIcon} from "./icons";
    import Modal, {bind} from 'svelte-simple-modal';
    import {writable} from "svelte/store";

    import SwiperCore, {A11y, Navigation, Pagination} from 'swiper';

    import {Swiper, SwiperSlide} from 'swiper/svelte';
    import {Popup} from "../../components";

    const data = [
        {
            modal_image: "./assets/images/gallery/twilight/big.jpg",
            img: "./assets/images/gallery/twilight/medium.jpg",
            thumbnail_image: "./assets/images/gallery/twilight/small.jpg",
            title: "Twilight at the foot of Mount Fuji",
            author: "Zoe Sazykina",
            description: "There opens a wonderful view to the mount Fuji from pagoda Chureito on a hilltop in Arakurayama Sengen Park. In the painting we see how it gradually begins to get dark. An echo of the sunset has remained in the sky still illuminating the right slope of the mountain and painting it in pink-lilac shades thus further emphasizing the beauty of the pagoda's forms. But despite this, lights begin to come on in the settlements located at the foot of the mountain. And in the foreground are gardens with cherry blossom, which delicate petals are illuminated by lighting from the streetlights on the road leading to the hill.",
        },
        {
            modal_image: "./assets/images/gallery/plums/big.jpg",
            img: "./assets/images/gallery/plums/medium.jpg",
            thumbnail_image: "./assets/images/gallery/plums/small.jpg",
            title: "Plums",
            author: "Zoe Sazykina",
            description: "",
        },
        {
            modal_image: "./assets/images/gallery/piano/big.jpg",
            img: "./assets/images/gallery/piano/medium.jpg",
            thumbnail_image: "./assets/images/gallery/piano/small.jpg",
            title: "Piano girl",
            author: "Zoe Sazykina",
            description: "",
        },
        {
            modal_image: "./assets/images/gallery/kyoto/big.jpg",
            img: "./assets/images/gallery/kyoto/medium.jpg",
            thumbnail_image: "./assets/images/gallery/kyoto/small.jpg",
            title: "Kyoto. On the way to Kiyomizu-dera",
            author: "Zoe Sazykina",
            description: "",
        },
        {
            modal_image: "./assets/images/gallery/polyommatus/big.jpg",
            img: "./assets/images/gallery/polyommatus/medium.jpg",
            thumbnail_image: "./assets/images/gallery/polyommatus/small.jpg",
            title: "Polyommatus icarus",
            author: "Zoe Sazykina",
            description: "",
        }
    ];

    let sliderIndex;
    $: sliderIndex = 0;
    let numIndex;
    $: numIndex = 0;
    let selectSrc;
    $: selectSrc = data[sliderIndex].img;

    let items = [];
    $: items = data.map(({title, img}, i) => ({
        originalPos: i,
        img,
        title,
    })).filter((_, i) => (numIndex <= i && i <= numIndex + 3))

    export const modal = writable(null);

    const showPopup = () => {
        if (document.body.clientWidth >= 768) {
            modal.set(bind(Popup, {src: data[sliderIndex].modal_image}));
        }
    }

    SwiperCore.use([Pagination, A11y, Navigation]);

    const onPrevSlide = () => {
        document.getElementsByClassName('swiper-button-prev')[0].click();
    }

    const onNextSlide = () => {
        document.getElementsByClassName('swiper-button-next')[0].click();
    }
</script>

<style type="text/scss">
  .gallery {
    width: 65%;
    margin: 85px auto;

    &__title {
      display: flex;
      justify-content: flex-end;
      font-family: "Metropolis-SemiBold", sans-serif;
      font-size: 30px;
      line-height: 24px;
      color: var(--sapphire);
      margin-top: 11px;

      span {
        display: block;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
  }

  .slider {
    width: 100%;
    margin: 20px 0 0;
    overflow: hidden;

    .info {
      margin: 30px 0;

      &__title {
        font-family: "Metropolis-Regular", sans-serif;
        font-size: 24px;
        line-height: 24px;
        color: var(--sapphire);
        margin-bottom: 15px;
      }

      &__author {
        font-family: "Metropolis-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 16px;
        color: var(--grey);
        margin-bottom: 15px;
      }

      &__description {
        font-family: "Metropolis-Regular", sans-serif;
        font-size: 18px;
        line-height: 26px;
        color: var(--sapphire);
      }
    }
  }

  .slider-mobile {
    display: none;

    .images {
      width: 100%;
      overflow: hidden;
      position: relative;

      .image {
        height: 32vw;
      }

      img {
        cursor: pointer;
        max-height: 100%;
        max-width: 100%;
        width: auto;
        height: auto;
        margin: auto;
        display: block;
      }
    }
  }

  .slider-desktop {
    .images {
      width: 100%;
      overflow: hidden;
      position: relative;

      .image {
        height: 25vw;

        > div {
          height: 100%;
        }
      }

      img {
        cursor: pointer;
        max-height: 100%;
        max-width: 100%;
        width: auto;
        height: auto;
        margin: auto auto auto 0;
        display: none;
      }

      .active {
        display: block;
      }
    }
  }

  .mini-slider {
    width: 100%;
    position: relative;

    .control-panel {
      display: flex;
      justify-content: flex-end;
      margin: 0 0 15px auto;

      &__buttons {
        &[data-active="false"] {
          pointer-events: none;
        }

        position: absolute;
        top: 50%;
        margin: auto;
        z-index: 10;
        -webkit-transform: translate(0, -50%);
        -moz-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        -o-transform: translate(0, -50%);
        transform: translate(0, -50%);
      }

      &__prev {
        left: -40px;
      }

      &__next {
        right: -40px;
      }

      &__pagination {
        width: 90px;
        font-family: "Metropolis-Regular", sans-serif;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        color: var(--sapphire);
      }
    }

    .images {
      width: 100%;
    }

    .image-block {
      cursor: pointer;
      margin-right: 5px;

      .image {
        width: 100%;

        > img {
          cursor: pointer;
          max-height: 100%;
          max-width: 100%;
          width: auto;
          height: auto;
          margin: auto auto auto 0;
          display: block;
        }
      }

      .title {
        margin-top: 15px;
        font-family: "Metropolis-Regular", sans-serif;
        font-size: 18px;
        line-height: 18px;
        color: var(--sapphire);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }

  @media screen and (max-width: 1919px) {
    .gallery {
      &__title {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .slider {
      .info {
        &__title {
          font-size: 20px;
          line-height: 20px;
          margin-bottom: 15px;
        }

        &__author {
          font-size: 12px;
          line-height: 12px;
          margin-bottom: 15px;
        }

        &__description {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    .mini-slider {
      .control-panel {
        margin: 0 0 25px auto;
      }

      .image-block {
        .image {
          margin-bottom: 10px;
        }

        .title {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .gallery {
      width: 60%;
    }
  }

  @media screen and (max-width: 1024px) {
    .gallery {
      width: 100%;
      margin: 80px auto;

      &__title {
        display: flex;
        justify-content: flex-start;
        font-size: 20px;
        margin: 0 20px;

        span {
          margin: 5px 0 0 30px;
        }
      }
    }

    .content {
      margin: auto 50px auto 20px;
    }

    .slider {
      .info {
        margin-bottom: 0;
      }
    }

    .slider-mobile {
      display: block;
    }

    .slider-desktop {
      display: none;
    }

    .mini-slider {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .gallery {
      width: 100%;
      margin: 50px auto 0;
    }
    .content {
      margin: 30px 0;
    }
    .slider {
      .info {
        margin: 30px 15px 0;
      }
    }
    .slider-mobile {
      .image {
        height: 73vw !important;
      }
    }
  }

</style>

<div class="gallery">
    <div class="gallery__title">
        <GalleryTitleIcon/>
        <span>Gallery</span>
    </div>
    <div class="content">
        <div class="slider">
            <div class="slider-desktop">
                <div class="images">
                    <div class="image">
                        {#each data as item, i}
                            <img alt="image" class="image-height {i == sliderIndex ? 'active' : ''}"
                                 on:click={showPopup} src={item.img}/>
                        {/each}
                    </div>
                </div>
            </div>
            <div class="slider-mobile">
                <div class="images">
                    <div class="image">
                        <Swiper
                                on:slideChange={(e) => sliderIndex = e.detail[0][0].activeIndex}
                                on:swiper={() => {}}
                                pagination={{ clickable: true }}
                                slidesPerView={1}
                                spaceBetween={50}
                                style='height: 100%'
                        >
                            {#each data as item, i}
                                <SwiperSlide>
                                    <img alt="image" src={item.img}/>
                                </SwiperSlide>
                            {/each}
                        </Swiper>
                    </div>
                </div>
            </div>
            <div class="info">
                <div class="info__title">{data[sliderIndex].title}</div>
                <div class="info__author">{data[sliderIndex].author}</div>
                <div class="info__description">{data[sliderIndex].description}</div>
            </div>
        </div>
        <div class="mini-slider">
            {#if data.length >= 5}
                <div class="control-panel">
                    <div class="control-panel__buttons control-panel__prev" data-active={numIndex !== 0}
                         on:click={onPrevSlide}
                    >
                        <PrevIcon isActive={numIndex !== 0} size="small"/>
                    </div>
                    <div class="control-panel__buttons control-panel__next"
                         data-active={numIndex + 4 < data.length}
                         on:click={onNextSlide}
                    >
                        <NextIcon isActive={numIndex + 4 < data.length} size="small"/>
                    </div>
                </div>
            {/if}
            <div class="images">
                <Swiper
                        on:slideChange={(e) => numIndex = e.detail[0][0].activeIndex}
                        on:swiper={() => {}}
                        navigation
                        slidesPerView={4}
                        spaceBetween={1}
                        style='height: 100%'
                >
                    {#each data as item, i}
                        <SwiperSlide>
                                <div class="image-block" on:click={() => sliderIndex = i} >
                                    <div class="image">
                                        <img alt="image" src="{item.thumbnail_image}"/>
                                    </div>
                                    <div class="title">{item.title}</div>
                                </div>
                        </SwiperSlide>
                    {/each}
                </Swiper>
            </div>
        </div>
    </div>
</div>
<Modal show={$modal} styleContent={{ display: 'flex', justifyContent: 'center' }}
       styleWindow={{ width: 'min-content', height: 'auto' }}>
</Modal>
